function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* Generated by peg.js using this grammar:
x-special/nautilus-clipboard
copy
file:///home/david/Descargas/parser.js

*/
import reduce from 'lodash/reduce';
import Parser from './tag_pattern_parser';

function toRegex(element) {
  var formatted = reduce(element, function (result, part) {
    if (typeof part === 'string') {
      return result + part;
    } else if (part.pattern === '*') {
      return result + '.*';
    } else {
      return result + '.';
    }
  }, '');
  return new RegExp("^".concat(formatted, "$"));
}

function filterTags(tags, orGroup) {
  var _reduce = reduce(orGroup, function (_ref, node) {
    var _ref2 = _slicedToArray(_ref, 2),
        allow = _ref2[0],
        exclude = _ref2[1];

    allow.push(toRegex(node.element));
    exclude.push.apply(exclude, _toConsumableArray(node.exclude.map(toRegex)));
    return [allow, exclude];
  }, [[], []]),
      _reduce2 = _slicedToArray(_reduce, 2),
      allowed = _reduce2[0],
      excluded = _reduce2[1];

  return tags.filter(function (t) {
    return allowed.some(function (p) {
      return p.test(t);
    });
  }).filter(function (t) {
    return excluded.every(function (p) {
      return !p.test(t);
    });
  });
}

export function selectByPattern(pattern, tags) {
  var andGroups = Parser.parse(pattern);
  return reduce(andGroups, filterTags, tags);
}